import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7863c829"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "treatment-button card-header cursor-pointer" }
const _hoisted_2 = { class: "custom-card" }
const _hoisted_3 = { class: "p-9" }
const _hoisted_4 = { class: "grid grid-cols-2 gap-y-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-2 uppercase bg-gray-100" }, "Nom", -1))
const _hoisted_6 = { class: "p-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-2 uppercase bg-gray-100" }, "Prénom", -1))
const _hoisted_8 = { class: "p-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-2 uppercase bg-gray-100" }, "Email", -1))
const _hoisted_10 = { class: "p-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-2 uppercase bg-gray-100" }, "Roles", -1))
const _hoisted_12 = { class: "p-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-2 uppercase bg-gray-100" }, "Société", -1))
const _hoisted_14 = { class: "p-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-2 uppercase bg-gray-100" }, "Dernière connexion", -1))
const _hoisted_16 = { class: "p-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-2 uppercase bg-gray-100" }, "Téléphone", -1))
const _hoisted_18 = { class: "p-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-2 uppercase bg-gray-100" }, "Profil:", -1))

import {PropType, computed, ref, onMounted} from "vue";
import {UserBlacklistHistorique} from "@/models/blacklisting/UserBlacklistHistorique";
import Tag from "primevue/tag";
import Button from "primevue/button";
import ChangeBlacklistStateModal from "@/components/modal/blacklisting/ChangeBlacklistStateModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserProfilTable',
  props: {
  data: {
    type: Object as PropType<UserBlacklistHistorique>,
    required: true,
  }
},
  setup(__props) {

const props = __props;

const showDialog = ref(false);


const rolesData = [
  { role: 'ROLE_ADMIN', severity: 'warning', label: 'Administrateur' },
  { role: 'ROLE_MANAGER', severity: 'danger', label: 'Manager' },
  { role: 'ROLE_CUSTOMER', severity: 'info', label: 'Utilisateur' },
  { role: 'ROLE_DEMO', severity: 'success', label: 'Demo' },
  { role: 'ROLE_SUPPLIER', severity: 'contrast', label: 'Fournisseur' },
];
const filteredRolesData = computed(() =>
    rolesData.filter(role => props.data.user.roles.includes(role.role))
);
const appLegacyUrl = ref<string|undefined>('');

onMounted(async () => {
    appLegacyUrl.value = process.env.VUE_APP_LEGACY_URL;
});

const redirectToLegacyUserProfil = () => {
    window.location.href = `${appLegacyUrl.value}admin/user/${props.data.user.uuid}/detail`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ChangeBlacklistStateModal, {
      "historique-blacklist": __props.data,
      visible: showDialog.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((showDialog).value = $event))
    }, null, 8, ["historique-blacklist", "visible"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Button), {
        label: props.data.state ? 'Modifier' : 'Traiter',
        severity: "info",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (showDialog.value = true))
      }, null, 8, ["label"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(props.data.user.lastname), 1),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, _toDisplayString(props.data.user.firstname), 1),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, _toDisplayString(props.data.user.email), 1),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredRolesData.value, (role) => {
              return (_openBlock(), _createBlock(_unref(Tag), {
                key: role.role,
                severity: role.severity,
                value: role.label,
                class: "mx-1",
                rounded: ""
              }, null, 8, ["severity", "value"]))
            }), 128))
          ]),
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, _toDisplayString(props.data.user.company.name), 1),
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, _toDisplayString(props.data.user.lastLoginAt), 1),
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, _toDisplayString(props.data.user.phoneNumber), 1),
          _hoisted_19,
          _createVNode(_unref(Button), {
            class: "p-2 text-left",
            icon: "pi pi-search",
            size: "small",
            unstyled: "unstyled",
            onClick: redirectToLegacyUserProfil
          })
        ])
      ])
    ])
  ], 64))
}
}

})